import React from "react";
import { TextInput } from "@mantine/core";

const commonInputStyles = {
  label: {
    fontSize: "16px",
    fontWeight: 700,
  },
  input: {
    fontSize: "18px",
    "::placeholder": {
      fontSize: "18px",
      color: "#AAAAAA",
    },
  },
};

export default function TextInputField({ name, value, onChange, ...props }) {
  return (
    <TextInput
      styles={commonInputStyles}
      value={value}
      onChange={(event) => onChange(name, event.currentTarget.value)}
      {...props}
    />
  );
}
